import { Link } from "react-router-dom";
import { SampleBadge, SourceTag, Decision } from "../Badges";

const OWN = { DGC: "pill-gold", Joint: "pill-blue", "Kennedy Osei": "pill-green" };
const ownKey = (o) => (o === "DGC" ? "DGC" : o === "Kennedy Osei" ? "Kennedy Osei" : "Joint");

export const EntityMap = ({ entities }) => {
  const groups = ["DGC", "Joint", "Kennedy Osei"].map((g) => [g, (entities || []).filter((e) => ownKey(e.ownership) === g)]);
  return (
    <div className="panel p-5" data-testid="entity-map">
      <div className="flex items-center justify-between mb-4">
        <div className="eyebrow">The State of DESPITE · {entities?.length || 0} entities</div>
        <SourceTag source="DGC authoritative entity map" />
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {groups.map(([g, list]) => (
          <div key={g}>
            <div className={`pill ${OWN[g]} mb-3`}>{g === "DGC" ? "DGC (Dr. Despite)" : g === "Joint" ? "Joint · Despite + Sarpong" : "Kennedy Osei"}</div>
            <div className="space-y-2">
              {list.map((e) => (
                <div key={e.name} className="bg-[#F4F8F5] border border-[color:var(--line)] rounded-sm p-3" data-testid={`entity-${e.name.replace(/\W+/g, "-").toLowerCase()}`}>
                  <div className="text-sm text-ink">{e.brands?.length ? e.brands.map((s) => <Link key={s} to={`/entities/${s}`} className="block hover:text-brand-green underline decoration-[color:var(--gold-hi)] underline-offset-2" data-testid={`entitymap-link-${s}`}>{s.replace(/-/g, " ")}</Link>) : e.known_as}</div>
                  <div className="text-[11px] text-slate-500">{e.name} · {e.sector}</div>
                  <div className="text-[10px] text-slate-400 mt-1">{e.ownership}</div>
                  <div className="text-[10px] text-amber-300/80 mt-1">{e.asset_note}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Decision>Every DGC holding, who it answers to, and which asset facts still need internal collection.</Decision>
    </div>
  );
};

export const Competitive = ({ rows }) => (
  <div className="panel p-5" data-testid="competitive-monitor">
    <div className="eyebrow mb-4">Competitive monitor · audience share</div>
    <div className="space-y-3">
      {(rows || []).map((r) => (
        <div key={r.station}>
          <div className="flex justify-between text-sm"><span className="text-ink">{r.station} <span className="text-slate-500 text-xs">· {r.group}</span></span><span className="font-data text-gold">{r.share != null ? `${r.share}%` : "not found"}</span></div>
          <div className="h-1 bg-slate-800 rounded-full mt-1"><div className="h-1 rounded-full bg-gold" style={{ width: `${(r.share || 0) * 5}%` }} /></div>
          <div className="text-[10px] text-slate-500 mt-1">{r.source}</div>
        </div>
      ))}
    </div>
    <div className="mt-3"><SampleBadge label="Needs audience-survey feed" /></div>
    <Decision>Where Peace FM stands against Multimedia Group once survey data is connected.</Decision>
  </div>
);
